import * as React from "react";
import { Accordion, Panel } from "baseui/accordion";
import { AdminRiskStateSection } from "./AdminRiskStateSection";
import { FC } from "react";
import { SummaryCard } from "./SummaryCard";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { SummaryTable } from "./SummaryTable"; // Adjust the import path as needed

type TExposureItem = {
  exposureId: string;
  name: string;
  is_policy_level: boolean;
  key: string;
  product_key: string;
  type: string;
  type_name: string;
};
type AdminExposuresSectionProps = {
  enabledExposures: TExposureItem[];
  availableCovers: TCoverSection[];
  quote: TQuote;
  riskProfile: TRiskProfile;
};
export const AdminExposureItemsSection: FC<AdminExposuresSectionProps> = ({
  enabledExposures,
  availableCovers,
  quote,
  riskProfile,
}) => {
  return (
    <Accordion>
      {enabledExposures?.map((enabledExposure, index) => {
        let price: TPrice = null;
        try {
          const prices = quote?.pricingOthers["premise"][enabledExposure?.key] ?? null;
          price = {
            "Pre-tax Premium": prices?.pre_tax_premium ?? 0,
            "Post-tax Premium": prices?.post_tax_premium ?? 0,
            Commission: prices?.commission ?? 0,
            Fees: prices?.installments[0].fees ?? 0,
            TotalFees: prices?.installments[0].inclusive_price ?? 0,
          };
        } catch (e) {
          console.error("Error getting price for exposure", enabledExposure?.key, e);
        }

        return (
          <Panel title={enabledExposure?.name} key={`${index}-${enabledExposure.key}`}>
            <AdminExposure
              exposureItem={enabledExposure}
              availableCovers={availableCovers}
              questionSets={quote?.product?.exposures
                ?.find((exp) => exp?.type === enabledExposure?.type)
                ?.exposureQuestionSets?.filter(
                  (eqs) => eqs?.exposureItemKey === enabledExposure?.key
                )
                ?.map((eqs) => eqs?.questionSet)}
              riskProfile={riskProfile}
              price={price}
            />
          </Panel>
        );
      })}
    </Accordion>
  );
};

type AdminExposureProps = {
  exposureItem: TExposureItem;
  availableCovers: TCoverSection[];
  questionSets: TQuestionSet[];
  riskProfile: TRiskProfile;
  price: TPrice;
};
const AdminExposure: FC<AdminExposureProps> = ({
  // availableCovers,
  // exposureItem,
  riskProfile,
  questionSets,
  price,
}) => {
  // const availableExposureCovers = availableCovers?.filter((cover) => {
  //   return cover?.key?.includes(exposureItem?.key);
  // });

  return (
    <VerticalSpacer>
      <SummaryCard data-testid="adminCoversSection" title="Price">
        {price ? <PriceSummary prices={price} /> : <p>No prices available</p>}
      </SummaryCard>
      <SummaryCard data-testid="adminPolicyHolderSection" title="Exposure details">
        <AdminRiskStateSection riskProfile={riskProfile} questionSets={questionSets} />
      </SummaryCard>
    </VerticalSpacer>
  );
};

type TFee = { feeType: { key: string }; amount: number };
type TPrice = {
  "Pre-tax Premium": number;
  "Post-tax Premium": number;
  Commission: number;
  Fees: TFee[];
  TotalFees: number;
};

type TPriceSummaryProps = {
  prices: TPrice;
};

export const PriceSummary: FC<TPriceSummaryProps> = ({ prices }) => {
  if (prices === null) {
    return <p>No prices available</p>;
  }

  // Create the data array for the SummaryTable
  const summaryData = [];

  summaryData.push({
    label: "Pre-tax Premium",
    value: `$${prices["Pre-tax Premium"].toFixed(2)}`,
  });
  summaryData.push({ label: "Commission", value: `$${prices.Commission.toFixed(2)}` });
  // Add each fee as a separate row
  prices.Fees.forEach((fee) => {
    summaryData.push({
      label: fee.kind.toUpperCase(),
      value: `$${fee.amount.toFixed(2)}`,
    });
  });

  summaryData.push({
    label: "Post-tax Premium",
    value: `$${prices["Post-tax Premium"].toFixed(2)}`,
  });

  // Define columns for the SummaryTable
  // const columns = [
  //   { label: "Type", key: "label" }, // Using 'label' for the first column name
  //   { label: "Amount", key: "value" }, // Using 'value' for the second column name
  // ];

  // return <>{Object.keys(prices)}</>;
  // Return the SummaryTable component with the prepared data and columns
  return <SummaryTable data={summaryData} columns={1} />;
};
